import axios from 'axios'

import { bus } from '../main'

import router from '../router'
import store from '../store'

export class NetworkService {

  public static async get(url: string) {
    const data : any = await axios.get(url)
      .catch(function (error) {
        if (error.response.status === 419 || error.response.status === 401) {
          if (store.getters['auth/authenticated'] == true) {
            bus.$emit('sessionTimeout')
          } else {
            return router.push({ name: 'Login' })
          }
        }
        else if (error.response.status === 404) {
          return router.push({ name: 'Not Found'})
        }
        return data
      })
    return data
  }

  public static async post(url: string, object: any = null) {
    let data: any
    if (object != null) {
      data = await axios.post(url, object)
        .catch(function (error) {
          if (error.response.status === 419 || error.response.status === 401) {
            if (store.getters['auth/authenticated'] == true) {
              bus.$emit('sessionTimeout')
            } else {
              return router.push({ name: 'Login' })
            }
          }
        })
    } else {
      data = await axios.post(url)
      .catch(function (error) {
        if (error.response.status === 419 || error.response.status === 401) {
          if (store.getters['auth/authenticated'] == true) {
            bus.$emit('sessionTimeout')
          } else {
            return router.push({ name: 'Login' })
          }
        }
      })
    }
    return data
  }

  public static async patch(url: string, object: any=null) {
    let data: any
    if (object != null) {
      data = await axios.patch(url, object)
        .catch(function (error) {
          if (error.response.status === 419 || error.response.status === 401) {
            if (store.getters['auth/authenticated'] == true) {
              bus.$emit('sessionTimeout')
            } else {
              return router.push({ name: 'Login' })
            }
          }
        })
    } else {
      data = await axios.patch(url)
        .catch(function (error) {
          if (error.response.status === 419 || error.response.status === 401) {
            if (store.getters['auth/authenticated'] == true) {
              bus.$emit('sessionTimeout')
            } else {
              return router.push({ name: 'Login' })
            }
          }
        })
    }
    return data
  }

  public static async delete(url: string) {
    let data : any
    data = await axios.delete(url)
      .catch(function (error) {
        return router.push({ name: 'Not Found' })
      })

    return data
  }
}